import { mergeProps, splitProps } from "solid-js";
import { Overlay as BaseOverlay, } from "solid-bootstrap-core";
import Fade from "./Fade";
const defaultProps = {
    transition: Fade,
    rootClose: false,
    show: false,
    placement: "top",
    popperConfig: {},
};
const Overlay = (p /*outerRef*/) => {
    const [local, outerProps] = splitProps(mergeProps(defaultProps, p), [
        "children" /*overlay*/,
        "transition",
        "ref",
    ]);
    const actualTransition = local.transition === true ? Fade : local.transition || undefined;
    return (<BaseOverlay {...outerProps} transition={actualTransition}>
      {local.children}
    </BaseOverlay>);
};
export default Overlay;
